




























































import { Vue, Component, Prop } from "vue-property-decorator";
import { AgentReportsBillParams } from "@/services/agent-reports";
import { getCurrentCompanyId } from "@/plugins/roles";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import CSingleSelect from "@/components/form/CSingleSelect.vue";
import { AgentListClass } from "@/classes/list/AgentListClass";
import { ContractorsListClass } from "@/classes/list/ContractorsListClass";

@Component({
  components: { CSingleSelect, CustomButton, CBlock }
})
export default class AgentBillFilter extends Vue {
  @Prop({ default: false }) isLoading?: boolean;
  agentList: AgentListClass = new AgentListClass();
  contractorList: ContractorsListClass = new ContractorsListClass();
  params: AgentReportsBillParams = {
    agentId: "",
    contractorId: "",
    companyId: this.companyId,
    sort: "formedAt",
    order: "DESC",
    responsibleId: "",
    paid: undefined
  };

  get companyId() {
    return getCurrentCompanyId();
  }

  applyFilter() {
    this.$emit("applyFilter", this.params);
  }

  clearFilter() {
    this.params.agentId = undefined;
    this.params.contractorId = undefined;
    this.params.responsibleId = undefined;
    this.params.paid = undefined;
    this.$emit("clearFilter", this.params);
  }
}
